/* eslint-disable prefer-const */
import { throttle } from 'lodash'

export const mixins = {
  mounted () {
    this.updateScreen()
    window.addEventListener('resize', () => {
      this.updateScreen()
    })
  },
  methods: {
    updateScreen: throttle(function () {
      console.log('update screen')
      let height, width
      height = window.innerHeight
      width = window.innerWidth
      this.$store.commit('screen/update', {
        width,
        height
      })
    }, 200)
  }
}
export default mixins
